import JSZip from 'jszip';
import { renderAsync } from 'docx-preview';
import { DOCX_CLASS } from './docxPreviewDom';

/**
 * A continuous section break (sectPr inside a paragraph's properties) only changes layout mid-page, but
 * docx-preview starts a new page at every section, leaving a spurious blank page in templates that use one.
 */
const CONTINUOUS_SECTION =
    /<w:sectPr\b(?:(?!<\/w:sectPr>)[\s\S])*?<w:type w:val="continuous"\/>(?:(?!<\/w:sectPr>)[\s\S])*?<\/w:sectPr>(?=<\/w:pPr>)/g;

/** Removes mid-document continuous section breaks from word/document.xml; the final section is kept. */
export function stripContinuousSectionBreaks(documentXml: string): string {
    return documentXml.replace(CONTINUOUS_SECTION, '');
}

async function normalizeForPreview(data: ArrayBuffer): Promise<ArrayBuffer> {
    const zip = await JSZip.loadAsync(data);
    const part = zip.file('word/document.xml');
    if (!part) {
        return data;
    }

    const xml = await part.async('string');
    const patched = stripContinuousSectionBreaks(xml);
    if (patched === xml) {
        return data;
    }

    zip.file('word/document.xml', patched);
    return zip.generateAsync({ type: 'arraybuffer' });
}

/**
 * Renders a .docx into bodyContainer. docx-preview empties styleContainer on every render, so it must be an
 * element of its own - never a document head.
 */
export async function renderDocx(data: ArrayBuffer, bodyContainer: HTMLElement, styleContainer: HTMLElement): Promise<void> {
    await renderAsync(await normalizeForPreview(data), bodyContainer, styleContainer, {
        className: DOCX_CLASS,
        inWrapper: true,
        breakPages: true,
        ignoreLastRenderedPageBreak: true,
        renderHeaders: true,
        renderFooters: true,
        renderFootnotes: true,
        renderEndnotes: true,
        renderComments: false,
        renderChanges: false,
        useBase64URL: true,
    });
}



// WEBPACK FOOTER //
// ./src/components/common/docxPreview/renderDocx.ts